<template>
  <div>
    <b-card class="p-3">
      <div class="d-flex flex-row align-items-center">
        <input-date
          ref="dataInicial"
          class="mr-3"
          :label="$t('ARQUIVO_RETORNO.DATA_INICIO')"
          v-model="form.dataInicial"
          required
        ></input-date>
        <input-date
          ref="dataFinal"
          :label="$t('ARQUIVO_RETORNO.DATA_FIM')"
          v-model="form.dataFinal"
          required
        ></input-date>
        <div class="ml-auto pl-4 pt-3 pb-3 border-left">
          <b-button @click="limparFiltro" variant="secondary" class="pl-4 pr-4">
            {{ $t("ARQUIVO_RETORNO.LIMPAR") }}
          </b-button>
          <b-button @click="listar" variant="primary" class="pl-4 pr-4 ml-2">
            {{ $t("GERAL.PESQUISAR") }}
          </b-button>
        </div>
      </div>
    </b-card>

    <b-card class="mt-3">
      <b-table
        head-variant="light"
        small
        striped
        :items="items"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
      >
        <template #cell(_)="item">
          <div class="d-flex justify-content-center pr-4">
            <b-button variant="default" @click="baixarArquivo(item.item)">
              <i class="fas fa-download"></i>
            </b-button>
          </div>
        </template>
      </b-table>

      <div class="header-table-operacoes">
        <b-form-group
          label="Por Pagina"
          label-for="per-page-select"
          label-class="fw-medium"
          class="por-pagina"
        >
          <b-form-select
            id="per-page-select"
            v-model="perPage"
            :options="pageOptions"
          >
          </b-form-select>
        </b-form-group>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
        ></b-pagination>
      </div>
    </b-card>
  </div>
</template>

<script>
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { InputDate } from "@/components/inputs";
import ArquivoRetornoService from "@/common/services/arquivo-retorno/arquivoRetorno.service";
import CedenteService from "@/common/services/cedente/cedente.service";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import FileSaver from "file-saver";
import { Base64 } from "js-base64";

export default {
  name: "Index",
  components: {
    InputDate,
  },
  data() {
    return {
      form: {},
      items: [],
      fields: [
        {
          key: "nome_Empresa",
          label: this.$t("ARQUIVO_RETORNO.EMPRESA"),
        },
        {
          key: "codigo_Empresa",
          label: this.$t("ARQUIVO_RETORNO.NUMERO"),
        },
        {
          key: "data_preparacao",
          label: this.$t("ARQUIVO_RETORNO.DATA_PREPARACAO"),
        },
        {
          key: "nome_Arquivo",
          label: this.$t("ARQUIVO_RETORNO.ARQUIVO"),
        },
        {
          key: "arquivo_pendente",
          label: this.$t("ARQUIVO_RETORNO.ARQ_PEN_FIN"),
        },
        {
          key: "_",
          label: this.$t("ARQUIVO_RETORNO.DOWNLOAD"),
        },
      ],
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      pageOptions: [
        5,
        10,
        15,
        { value: 100, text: this.$t("GERAL.PAGINACAO") },
      ],
    };
  },
  mounted() {
    this.$store.dispatch(DEFINIR_BREADCRUMB, [
      { titulo: this.$t("MENU.ARQUIVO_RETORNO") },
    ]);
  },
  methods: {
    listar() {
      if (!this.validarFormulario()) return;
      this.$store.dispatch(START_LOADING);
      let form = {
        tamanhoDaPagina: this.perPage,
        numeroDaPagina: this.currentPage,
        ...this.form,
      };
      let params = CedenteService.objectToQueryString(form);
      ArquivoRetornoService.listar(params)
        .then((result) => {
          if (result.data.data.itens.length > 0)
            this.items = result.data.data.itens;
          else this.items = [];
        })
        .catch((err) => console.log(err))
        .finally(() => this.$store.dispatch(STOP_LOADING));
    },
    validarFormulario() {
      let arValidation = [];
      arValidation.push(this.$refs.dataInicial.valid());
      arValidation.push(this.$refs.dataFinal.valid());
      return arValidation.filter((elem) => elem == false).length == 0;
    },
    baixarArquivo(value) {
      let decodedFile = Base64.decode(`${value.arquivo_Base64}`);
      let file = new File([decodedFile], `${value.nome_Arquivo}`, {
        type: "text/plain;charset=utf-8",
      });
      FileSaver.saveAs(file);
    },
    limparFiltro() {
      this.form = {};
      this.items = [];
    },
  },
};
</script>

<style></style>
